import { Link } from 'react-router-dom';

export default function ComparisonSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3">
              / Comparaison /
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900">
              Pourquoi Hipobuy Spreadsheet ?
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              Découvrez comment Hipobuy Spreadsheet se compare aux autres outils du marché
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] text-sm">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-4 px-4 font-heading font-semibold text-foreground-900">Outil</th>
                  <th className="text-center py-4 px-4 font-heading font-semibold text-foreground-900">Performance</th>
                  <th className="text-center py-4 px-4 font-heading font-semibold text-foreground-900">Automatisation</th>
                  <th className="text-center py-4 px-4 font-heading font-semibold text-foreground-900">Facilité</th>
                  <th className="text-center py-4 px-4 font-heading font-semibold text-foreground-900">Prix</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-200/60 bg-primary-50/50">
                  <td className="py-4 px-4">
                    <strong className="text-primary-700 font-heading">Hipobuy Spreadsheet</strong>
                  </td>
                  <td className="text-center py-4 px-4 text-accent-600">★★★★★</td>
                  <td className="text-center py-4 px-4 text-foreground-700">Avancée</td>
                  <td className="text-center py-4 px-4 text-foreground-700">Simple</td>
                  <td className="text-center py-4 px-4 text-foreground-700">
                    <Link to="/article/hipobuy-spreadsheet-tarifs" className="text-primary-600 hover:text-primary-700 underline text-xs whitespace-nowrap">Voir tarifs →</Link>
                  </td>
                </tr>
                <tr className="border-b border-background-200/60">
                  <td className="py-4 px-4 text-foreground-700">Google Sheets</td>
                  <td className="text-center py-4 px-4 text-foreground-700">★★★☆☆</td>
                  <td className="text-center py-4 px-4 text-foreground-700">Limitée</td>
                  <td className="text-center py-4 px-4 text-foreground-700">Moyen</td>
                  <td className="text-center py-4 px-4 text-foreground-700">
                    <Link to="/article/hipobuy-spreadsheet-vs-google-sheets" className="text-primary-600 hover:text-primary-700 underline text-xs whitespace-nowrap">Comparer →</Link>
                  </td>
                </tr>
                <tr className="border-b border-background-200/60">
                  <td className="py-4 px-4 text-foreground-700">Airtable</td>
                  <td className="text-center py-4 px-4 text-foreground-700">★★★★☆</td>
                  <td className="text-center py-4 px-4 text-foreground-700">Bonne</td>
                  <td className="text-center py-4 px-4 text-foreground-700">Complexe</td>
                  <td className="text-center py-4 px-4 text-foreground-700">
                    <Link to="/article/hipobuy-spreadsheet-vs-airtable" className="text-primary-600 hover:text-primary-700 underline text-xs whitespace-nowrap">Comparer →</Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/article/guide-complet-hipobuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-700 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Lire le guide complet
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}